import {Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {forwardRef, useImperativeHandle, useState} from "react";
import {useEventUpdate} from "../../hooks/useEventUpdate";

const EventDeleteModal = forwardRef(({eventDetail, refetchEvents}, ref) => {
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState(""); // State to store error message
    const eventUpdateMutation = useEventUpdate();
    useImperativeHandle(
        ref,
        () => ({
            handleOpen,
        }),
        []
    );

    const handleOpen = () => {
        setErrorMessage("");
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setErrorMessage("");
    };
    const onDeleteSuccess = () => {
        refetchEvents();
        handleClose();
        eventUpdateMutation.reset();
    };

    const onDeleteError = (error) => {
        const message = error?.response?.data?.message || "Failed to delete the event. Please try again.";
        setErrorMessage(message);
    };
    const handleConfirmDelete = () => {
        const payload = {
            cancel: true,
            id: eventDetail.id,
        };
        eventUpdateMutation.mutate(payload, {
            onSuccess: onDeleteSuccess,
            onError: onDeleteError,
        });
    };
    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
                <DialogContentText>Are you sure you want to delete this event?</DialogContentText>
                <DialogContentText>This action cannot be undone.</DialogContentText>
                {errorMessage && (
                    <Alert severity="error" sx={{mt: 2}} variant="outlined">
                        {errorMessage}
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="contained" color="primary">
                    Cancel
                </Button>
                <Button onClick={handleConfirmDelete} variant="contained" color="error" autoFocus>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
});
export default EventDeleteModal;
